import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, CircularProgress, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TablePagination, TableRow, Typography,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { CustomerService } from '../../services/customer.service';
import { Customer } from '../../interfaces/sales/customer.interface';
import { useToast } from '../../context/ToastContext';
import { AuthService } from '../../services/auth.service';

const CustomerList: React.FC = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [rows, setRows] = useState<Customer[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, [page, size]); // eslint-disable-line react-hooks/exhaustive-deps

  const load = async () => {
    const institutionId = AuthService.getSelectedInstitution();
    try {
      setLoading(true);
      const res = await CustomerService.listByInstitution(institutionId, page, size);
      setRows(res.content);
      setTotal(res.totalElements);
    } catch (e) {
      toast.showApiError(e, 'Failed to load customers');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h5">Customers</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/sales/customers/new')}>
          New Customer
        </Button>
      </Box>
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Contact Person</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(r => (
                <TableRow
                  key={r.id}
                  hover
                  sx={{ cursor: 'pointer' }}
                  onClick={() => navigate(`/sales/customers/${r.id}`)}
                >
                  <TableCell>{r.name}</TableCell>
                  <TableCell>{r.contactPerson ?? '—'}</TableCell>
                  <TableCell>{r.email ?? '—'}</TableCell>
                  <TableCell>{r.phone ?? '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={(_, p) => setPage(p)}
            rowsPerPage={size}
            onRowsPerPageChange={(e) => { setSize(Number(e.target.value)); setPage(0); }}
          />
        </TableContainer>
      )}
    </Box>
  );
};

export default CustomerList;
